export default "__VITE_ASSET__46064725__"